export default "__VITE_ASSET__dwVrj2sx__"